import {Component, OnInit, AfterViewInit, ViewChild, ElementRef, HostListener, Input} from '@angular/core';
import {Constants} from '../shared/constants';
import {Utils} from '../shared/utils/utils';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewInit {

  currentLang = 'en';

  navItems = [
    // {title: 'Services', id: 'services'},
    // {title: 'References', id: 'portfolio'},
    // {title: 'About us', id: 'about'},
    // // {title: 'Team', id: 'team'},
    // {title: 'Contact', id: 'contact'},
  ];

  @ViewChild('mainNav') nav: ElementRef;
  @ViewChild('navbarMobile') navbarMobile: ElementRef;

  offsetTop: number;

  @Input() scrollToArgs;

  constructor(private translateService: TranslateService) {
    this.translateService.onLangChange.subscribe(
      newLang => {
        this.currentLang = newLang.lang;
        if (this.currentLang === 'hu') {
          this.navItems = [
            {title: 'Szervizek', id: 'services'},
            {title: 'Referenciák', id: 'portfolio'},
            {title: 'Rólunk', id: 'about'},
            {title: 'Kapcsolat', id: 'contact'},
          ];
        }
        if (this.currentLang === 'en') {
          this.navItems = [
            {title: 'Services', id: 'services'},
            {title: 'References', id: 'portfolio'},
            {title: 'About us', id: 'about'},
            {title: 'Contact', id: 'contact'},
          ];
        }

      }
    );
  }

  get _s() { // Alias
    return this.scrollToArgs;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this._refreshOffset();
  }

  @HostListener('window:scroll', [])
  @HostListener('window:touchmove', [])
  onWindowScroll() {
    this._refreshOffset();
    // console.log("offsetTop: " + this.offsetTop);
  }

  private _calcOffset(): number {
    let offset = Utils.local.offset(this.nav.nativeElement);
    return offset.top;
  }

  private _refreshOffset(): void {
    this.offsetTop = this._calcOffset();
  }

  onNavItemClicked(): void {
    $(this.navbarMobile.nativeElement).collapse('hide');
  }

  selectLang(lang: string, event) {
    event.stopPropagation();
    event.preventDefault();
    this.translateService.use(lang);
  }
}



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/navigation/navigation.component.ts